let state = {
  
    setProfessor: '',
    allMateriasProfessor: '',


}

export default state